import TwoColumnsWithSquareImage from '@/components/TwoColumnsWithSquareImage'

const IsoCertifiedFintech = () => (
    <TwoColumnsWithSquareImage
        image={{
            src: '/images/fintech-and-banking/iso-certified.png',
            alt: `ISO Certified`,
        }}
        title={`ISO-certified emission tracking`}
        paragraph={
            <>
                {`Over 50,000 companies are bound by regulation to report on their scope 3 emissions. They need solutions, fast. Equip them with industry-leading emission calculations anchored in the GHG Protocol, the leading carbon accounting standard.`}
            </>
        }
        imageOnRight
    />
)

export default IsoCertifiedFintech
